import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Traders retail que usan indicadores y sienten que pierden el control tras un trade fallido.', 'Personas que operan cripto, forex o índices y sufren de trading de venganza.', 'Traders de cuentas de fondeo que están a punto de tocar el límite de pérdida diaria.', 'Cualquier persona que ame el trading pero odie la montaña rusa emocional que conlleva.'];
const notForWho = ['Personas que buscan dinero fácil sin seguir reglas.', 'Inversores de largo plazo que no operan activamente.', 'Traders que no están dispuestos a alejarse de la pantalla cuando el plan lo exige.'];
export const TargetAudience = () => {
  return <section className="py-16 md:py-24 bg-black relative border-y border-white/5" data-id="element-173">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-174">
        <div className="grid md:grid-cols-2 gap-10 md:gap-12" data-id="element-175">
          {/* WHO IT IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-176">
            <h2 className="text-2xl sm:text-3xl mb-6 md:mb-8 flex items-center gap-3 flex-wrap" data-id="element-177">
              <span className="text-brand-green" data-id="element-178">ESTO ES PARA TI</span> SI:
            </h2>
            <ul className="space-y-4 md:space-y-6" data-id="element-179">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-3 md:gap-4" data-id="element-180">
                  <div className="mt-1 bg-brand-green/20 p-1 rounded-full shrink-0" data-id="element-181">
                    <Check className="w-4 h-4 text-brand-green" data-id="element-182" />
                  </div>
                  <span className="text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-183">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* WHO IT IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="md:pl-12 md:border-l border-white/10 pt-6 md:pt-0 border-t md:border-t-0" data-id="element-184">
            <h2 className="text-2xl sm:text-3xl mb-6 md:mb-8 flex items-center gap-3 flex-wrap text-gray-500" data-id="element-185">
              <span className="text-brand-red" data-id="element-186">NO ES PARA TI</span> SI:
            </h2>
            <ul className="space-y-4 md:space-y-6" data-id="element-187">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-3 md:gap-4 opacity-70" data-id="element-188">
                  <div className="mt-1 bg-brand-red/20 p-1 rounded-full shrink-0" data-id="element-189">
                    <X className="w-4 h-4 text-brand-red" data-id="element-190" />
                  </div>
                  <span className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-191">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};